// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___UZiiM","fullScreen":"fullScreen___MhXMQ","button":"button___m5mPP","darkBtn":"darkBtn___IWbUC"};